import { Link } from 'react-router-dom'

import Title from '../components/items/Title'
import Technology from '../components/items/Technology'

import react from '../img/technology/react.png'
import css from '../img/technology/css.png'
import html from '../img/technology/html.png'
import javaScript from '../img/technology/javascript.png'
import typeScript from '../img/technology/typescript.png'

import styles from './otherProjects.module.css'

export default function OtherProjects() {
  return (
    <section id="About" className={styles.container}>
      <Title title="MUITO PRAZER," subTitle="ESTES SÃO MEUS PROJETOS" />
      <div className={styles.projectsContainer}>
        <Link to="/project7" className={styles.project7}>
          <div className={styles.overlay}>Rater</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={typeScript} name="TypeScript" />
          </div>
        </Link>
        <Link to="/project1" className={styles.project1}>
          <div className={styles.overlay}>Cineflix</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project2" className={styles.project2}>
          <div className={styles.overlay}>Management</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project3" className={styles.project3}>
          <div className={styles.overlay}>TripAdventure</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project4" className={styles.project4}>
          <div className={styles.overlay}>Utilities</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project5" className={styles.project5}>
          <div className={styles.overlay}>Pokedex</div>
          <div className={styles.containerTechnology}>
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={javaScript} name="JavaScript" />
          </div>
        </Link>
        <Link to="/project6" className={styles.project6}>
          <div className={styles.overlay}>Expert Notes</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={typeScript} name="TypeScript" />
          </div>
        </Link>
        <Link to="/project8" className={styles.project8}>
          <div className={styles.overlay}>Readme Generator</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={typeScript} name="TypeScript" />
          </div>
        </Link>
        <Link to="/project9" className={styles.project9}>
          <div className={styles.overlay}>Bakery</div>
          <div className={styles.containerTechnology}>
            <Technology img={react} name="React JS" />
            <Technology img={css} name="CSS" />
            <Technology img={html} name="HTML" />
            <Technology img={typeScript} name="TypeScript" />
          </div>
        </Link>
      </div>
    </section>
  )
}
